export class Option {

    private _name: string;
    private _color: string;

    constructor(name: string, color: string) {
        this._name = name;
        this._color = color;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get color(): string {
        return this._color;
    }

    set color(value: string) {
        this._color = value;
    }

    public serialize(): string {

        return JSON.stringify({
            name: this._name,
            color: this._color
        })

    }

    static parse(data: string): Option{
        const rawData = JSON.parse(data);

        return new Option(rawData.name, rawData.color);
    }


}